(() => {
  const initOffer = (section) => {
    if (section.dataset.fsInitialized === 'true') return;
    section.dataset.fsInitialized = 'true';

    const galleryTrack = section.querySelector('[data-fs-gallery-track]');
    const galleryImages = [...section.querySelectorAll('[data-fs-gallery-image]')];
    const galleryThumbs = [...section.querySelectorAll('[data-fs-thumb]')];
    const setGalleryIndex = (index, scroll) => {
      galleryThumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      if (scroll && galleryTrack) galleryTrack.scrollTo({ left: galleryTrack.clientWidth * index, behavior: 'smooth' });
    };

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => setGalleryIndex(Number(thumb.dataset.fsThumb), true));
    });

    let galleryFrame;
    galleryTrack?.addEventListener('scroll', () => {
      cancelAnimationFrame(galleryFrame);
      galleryFrame = requestAnimationFrame(() => {
        const index = Math.max(0, Math.min(galleryImages.length - 1, Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth)));
        setGalleryIndex(index, false);
      });
    }, { passive: true });

    const variantInput = section.querySelector('[data-fs-variant-id]');
    const buttonPrice = section.querySelector('[data-fs-button-price]');
    const buttonCompare = section.querySelector('[data-fs-button-compare]');
    const stickyPrice = section.querySelector('[data-fs-sticky-price]');
    const stickyCompare = section.querySelector('[data-fs-sticky-compare]');

    section.querySelectorAll('[data-fs-bundle]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        if (variantInput) variantInput.value = radio.value;
        if (buttonPrice) buttonPrice.textContent = radio.dataset.price;
        if (buttonCompare) buttonCompare.textContent = radio.dataset.comparePrice;
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        if (stickyCompare) stickyCompare.textContent = radio.dataset.comparePrice;
        section.querySelectorAll('.fs-control__bundle').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('.fs-control__bundle')?.classList.add('is-selected');
      });
    });

    const form = section.querySelector('.fs-control__form');
    const addButton = section.querySelector('.fs-control__add');
    const sticky = section.querySelector('[data-fs-sticky]');
    const updateSticky = () => {
      if (!addButton) return;
      sticky?.classList.toggle('is-visible', window.innerWidth < 800 && addButton.getBoundingClientRect().bottom < 0);
    };
    section.querySelector('[data-fs-sticky-add]')?.addEventListener('click', () => form?.requestSubmit());
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();

    section.querySelectorAll('.fs-control__video-row video').forEach((video) => {
      video.addEventListener('play', () => {
        section.querySelectorAll('.fs-control__video-row video').forEach((item) => {
          if (item !== video) item.pause();
        });
      });
    });

    const countdown = section.querySelector('[data-fs-demand-countdown]');
    if (countdown) {
      const duration = Math.max(1, Number(countdown.dataset.durationHours) || 8) * 60 * 60 * 1000;
      const storageKey = `fsDemandEndsAt:${window.location.pathname}`;
      let endTime;
      try {
        endTime = Number(window.sessionStorage.getItem(storageKey));
      } catch (error) {
        endTime = 0;
      }
      if (!endTime || endTime <= Date.now()) {
        endTime = Date.now() + duration;
        try {
          window.sessionStorage.setItem(storageKey, String(endTime));
        } catch (error) {
          // The timer still works when browser storage is unavailable.
        }
      }

      const renderCountdown = () => {
        if (!countdown.isConnected) return false;
        let remaining = Math.max(0, endTime - Date.now());
        if (remaining === 0) {
          endTime = Date.now() + duration;
          remaining = duration;
          try {
            window.sessionStorage.setItem(storageKey, String(endTime));
          } catch (error) {
            // The timer still works when browser storage is unavailable.
          }
        }
        const totalSeconds = Math.floor(remaining / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        countdown.textContent = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
        return true;
      };

      renderCountdown();
      const timer = window.setInterval(() => {
        if (!renderCountdown()) window.clearInterval(timer);
      }, 1000);
    }
  };

  const initComparison = (section) => {
    if (section.dataset.fsInitialized === 'true') return;
    section.dataset.fsInitialized = 'true';
    const input = section.querySelector('[data-fs-comparison-input]');
    const before = section.querySelector('[data-fs-before]');
    const line = section.querySelector('[data-fs-line]');
    if (!input || !before || !line) return;
    const update = () => {
      const value = input.value;
      before.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
      line.style.left = `${value}%`;
    };
    input.addEventListener('input', update);
    update();
  };

  const initReviews = (section) => {
    if (section.dataset.fsInitialized === 'true') return;
    section.dataset.fsInitialized = 'true';
    const track = section.querySelector('[data-fs-reviews-track]');
    section.querySelector('[data-fs-reviews-prev]')?.addEventListener('click', () => track?.scrollBy({ left: -410, behavior: 'smooth' }));
    section.querySelector('[data-fs-reviews-next]')?.addEventListener('click', () => track?.scrollBy({ left: 410, behavior: 'smooth' }));
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-fs-offer]').forEach(initOffer);
    scope.querySelectorAll('[data-fs-comparison-section]').forEach(initComparison);
    scope.querySelectorAll('[data-fs-featured-reviews]').forEach(initReviews);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
